import cookieStorage from 'helpers/cookieStorage';

const ALLOWED_FACEBOOK_PIXEL_PARAMS = /^_fb[cp]$/;

/**
 * Get Facebook pixel params (_fbp, _fbc) from a URL search string.
 * These are used for Facebook attribution tracking.
 */
export const getFacebookPixelParamsFromSearch = (
    search: string,
): Record<string, string> | null => {
    const searchParams = new URLSearchParams(search);
    let fbParams = {};

    searchParams.forEach((value, key) => {
        if (ALLOWED_FACEBOOK_PIXEL_PARAMS.test(key)) {
            fbParams = {
                ...fbParams,
                [key]: value,
            };
        }
    });

    return Object.keys(fbParams).length === 0 ? null : fbParams;
};

/**
 * Store Facebook pixel parameters as individual cookies.
 * Sets _fbp and _fbc cookies.
 */
export const storeFacebookPixelParams = (fbParams: Record<string, string>) => {
    Object.entries(fbParams).forEach(([key, value]) => {
        cookieStorage.setItem(key, value, {
            expires: 90
        });
    });
};
